import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { IValidateLoginCodeRequestData } from 'src/app/interfaces/authentication.interface';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from "src/app/components/menu/navigator";

@Component({
  selector: 'app-change-password-auth-app',
  templateUrl: './change-password-auth-app.component.html',
  styleUrls: ['./change-password-auth-app.component.scss'],
})
export class ChangePasswordAuthAppComponent  implements OnInit {

  @ViewChild(IonContent, {static: false}) content: IonContent;
  
  @Input() customerId: any;
  @Input() callback: () => void;
  @Input() onClose: () => void;
  @Input() isMFAFirst: any;
  
  error = null;
  authenticatorAppLoginForm: FormGroup;
  digit1: AbstractControl
  verifiedCode = false;

  constructor(
    public successMessageService: SuccessMessageService,
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private authenticationService: AuthenticationService,
    public globalErrorHandlerService: GlobalErrorHandlerService,
    private logoutService: LogoutService
  ) { }

  ngOnInit() {
    this.successMessageService.clearMessage();
    this.authenticatorAppLoginForm = new FormGroup({
      digit1: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit2: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit3: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit4: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit5: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)]),
      digit6: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(1), Validators.maxLength(1)])
		});

    this.userSessionService.getCustomer().subscribe((customer) => {
      if(customer){
        this.customerId = customer.customerId
      }
    })
  }

  onDigitInput(index: number, event: KeyboardEvent) {
    const target = event.target as HTMLInputElement;
    if (target.value.length > 1) {
      target.value = target.value.slice(0, 1); // Limit to one digit
    }

    this.authenticatorAppLoginForm.get(`digit${index + 1}`)?.setValue(target.value);
    if (target.value && index < 5) {
      (document.getElementsByTagName('ion-input')[index + 1].getInputElement() as unknown as Promise<HTMLIonInputElement>).then(inputElement => {
        inputElement.focus();
      });
    } else if (!target.value && index > 0) {
      // Move to the previous input if the current one is empty
      (document.getElementsByTagName('ion-input')[index - 1].getInputElement() as unknown as Promise<HTMLIonInputElement>).then(inputElement => {
        inputElement.focus();
      });
    }
  }
 
  handleKeydown(event: KeyboardEvent, index: number) {
    const target = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !target.value && index > 0) {
      (document.getElementById(`digit${index}`) as HTMLInputElement)?.focus();
    }
  }

  doVerify(){
    const combinedValue = 
        this.authenticatorAppLoginForm.value.digit1 +
        this.authenticatorAppLoginForm.value.digit2 +
        this.authenticatorAppLoginForm.value.digit3 +
        this.authenticatorAppLoginForm.value.digit4 +
        this.authenticatorAppLoginForm.value.digit5 +
        this.authenticatorAppLoginForm.value.digit6;
      
    const data: IValidateLoginCodeRequestData = {
      customerId: this.customerId,
      pinNumber: combinedValue,
      target: 'auth_app'
    }
    this.authenticationService.validateLoginCode(data).subscribe({
      next: response => {
        if (response && !!response.result) {
          this.verifiedCode = true;
          this.validateUserAction();
        }
        if('code' in response) {
          const error = this.globalErrorHandlerService;
          switch (response.code) {
              case 'LOGIN_CODE_NOT_FOUND':
                  error.setErrorMessage('Wrong code.');
                  this.authenticatorAppLoginForm.setErrors({ 'LOGIN_CODE_NOT_FOUND': true });
                  this.authenticatorAppLoginForm.markAsDirty();
                  this.authenticatorAppLoginForm.markAsTouched();
                  break;
              case 'LOGIN_CODE_EXPIRED':
                  error.setErrorMessage('Code expired.');
                  this.authenticatorAppLoginForm.setErrors({ 'LOGIN_CODE_EXPIRED': true });
                  this.authenticatorAppLoginForm.markAsDirty();
                  this.authenticatorAppLoginForm.markAsTouched();
                  break;
              case 'FAILED_TOO_MANY_ATTEMPTS':
                  error.setErrorMessage('Your account was disabled upon too many failed logins, please contact support.');
                  break;
              case "NOT_VALID_TOKEN":
                    this.authenticatorAppLoginForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
                    this.authenticatorAppLoginForm.markAsDirty();
                    this.authenticatorAppLoginForm.markAsTouched();
                    error.setErrorMessage('The token provided is not valid');
                    break;
              default:
                  error.setErrorMessage('An error has occured logging you in. Please try again.');
                  this.authenticatorAppLoginForm.setErrors({ 'LOGIN_CODE_SERVER_ERROR': true });
                  this.authenticatorAppLoginForm.markAsDirty();
                  this.authenticatorAppLoginForm.markAsTouched();
                  break;
          }
          this.error = error;
          this.authenticatorAppLoginForm.reset();
          //this.content.scrollToTop(10);
          
      } else {
        this.verifiedCode = true;
        this.validateUserAction();
      }
      },
      error: error => {
        switch (error.getErrorCode().toUpperCase()) {
          case 'LOGIN_CODE_NOT_FOUND':
            error.setErrorMessage('Wrong code.');
            this.authenticatorAppLoginForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
            this.authenticatorAppLoginForm.markAsDirty();
            this.authenticatorAppLoginForm.markAsTouched();
            break;
          case 'LOGIN_CODE_EXPIRED':
            error.setErrorMessage('Code expired.');
            this.authenticatorAppLoginForm.setErrors({ LOGIN_CODE_EXPIRED: true });
            this.authenticatorAppLoginForm.markAsDirty();
            this.authenticatorAppLoginForm.markAsTouched();
            break;
          case 'FAILED_TOO_MANY_ATTEMPTS':
            error.setErrorMessage('Your account was disabled upon too many failed logins, please contact support.');
            break;
          case "NOT_VALID_TOKEN":
            this.authenticatorAppLoginForm.setErrors({ LOGIN_CODE_NOT_FOUND: true });
            this.authenticatorAppLoginForm.markAsDirty();
            this.authenticatorAppLoginForm.markAsTouched();
            error.setErrorMessage('The token provided is not valid');
            break;
          default:
            error.setErrorMessage('An error has occured logging you in. Please try again.');
            this.authenticatorAppLoginForm.setErrors({ LOGIN_CODE_SERVER_ERROR: true });
            this.authenticatorAppLoginForm.markAsDirty();
            this.authenticatorAppLoginForm.markAsTouched();
            break;
        }
        this.verifiedCode = false;
        this.error = error;
        this.authenticatorAppLoginForm.reset();
        //this.content.scrollToTop(10);
      }
    })
  }

  validateUserAction() {
    this.navigator.navigateTo("ChangePasswordMFAStepTwoComponent");
  }


  closeModal = () => {
    if (!this.verifiedCode) {
        const onClose = this.onClose;
        if (onClose) {
          this.navigator.dismiss();
          onClose();
        } else {
          this.navigator.dismiss();
          return this.logoutService.onLogout();
        }
      } else {
        return setTimeout(() => {
          this.validateUserAction();
        }, 1000);
      }
  };

}
